const TOKEN_STORAGE_KEY = 'token';

export function isLoggedIn () {
  return !!getUserTokenInfo();
}

export type UserTokenInfoT = { token: string, expiresAt: number }

export function clearUserToken () {
  localStorage.removeItem(TOKEN_STORAGE_KEY);
  fireAuthStorageChange();
}

export function saveUserToken (tokenInfo: UserTokenInfoT) {
  localStorage.setItem(TOKEN_STORAGE_KEY, JSON.stringify(tokenInfo));
  fireAuthStorageChange();
}

export function getUserTokenInfo (): UserTokenInfoT | null {
  const tokenStr = localStorage.getItem(TOKEN_STORAGE_KEY) || '';
  try {
    const tokenJson = JSON.parse(tokenStr);
    if (tokenJson.expiresAt && tokenJson.expiresAt <= Date.now()) return null;
    return tokenJson;
  } catch (e) {
    return null;
  }
}

const authStorageChangeCbs: (() => any)[] = [];

export function onAuthStorageChange (cb: () => any) {
  authStorageChangeCbs.push(cb);
}

function fireAuthStorageChange () {
  authStorageChangeCbs.forEach(fn => fn())
}
